import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  message,
  Tabs,
  Input,
  DatePicker,
  Form, Popover,
  Checkbox
} from "antd";
import { withRouter } from "react-router-dom";
import StageSuccess from "../../svg/svgicon/StageIcon/StageSuccess";
import ButtonStage from "../../Components/MyComponent/ButtonStage";
import { API } from "../../../src/API/API";
import { baseConfig } from "../../Config/Config";
import UserContext from "../UserContext/UserContext";
import JoinWorkHeader from "./JoinWorkHeader";
import JoinWorkTask from "./JoinWorkTask/JoinWorkTask";
import JoinWorkNoteList from "./JoinWorkNotes/JoinWorkNoteList";
import JoinWorkRequirementList from "./JoinWorkRequirement/JoinWorkRequirement";
import JoinWorkDocumentList from "./JoinWorkDocument/JoinWorkDocument";
import JoinWorkProductReq from "./JoinWorkProductRequirement/JoinWorkProductReq";
import PopConfirm from "../../Components/MyComponent/PopConfirm";
import PrintComponent from "../../Components/PrintComponent/PrintComponent";
import JoinWorkToPDF from "./JoinWorkToPDF/JoinWorkToPDF";

const { TabPane } = Tabs;
const { TextArea } = Input;
const dateFormat = "YYYY.MM.DD";

var moment = require("moment");

class JoinWorkInvitation extends Component {
  static contextType = UserContext;
  state = {
    joinworkcode: "",
    joinworkname: "",
    tendertypename: null,
    departmentname: null,
    startdate: null,
    enddate: null,
    note: "",
    worklocation: "",
    workduration: "",
    status: 0,
    data: null,
    joinworkid: this.props.match.params.joinworkid,
    product_requirement: "",
    owner_products_supply: "",
    stage: 1,
    popConfirmVisible: false,
    isMasterContract: 0,
  };
    
  getData = () => {
    API.get("/getJoinWorkInitialData?joinworkid=" + this.props.match.params.joinworkid).then(
      (response) => {
        if (response.status === 200) {
          this.setState({
            tendertypelist: response.data.retData[0],
            deplist: response.data.retData[1],
          });
          // eniig zasna
          if (response.data.retData[2].length > 0) {
            this.setState((prevState) => ({
              joinworkcode: response.data.retData[2][0].joinworkcode,
              joinworkname: response.data.retData[2][0].joinworkname,
              tendertypename: response.data.retData[2][0].tendertypename,
              departmentname: response.data.retData[2][0].departmentname,
              tendertypeid: response.data.retData[2][0].tendertypeid,
              departmentid: response.data.retData[2][0].departmentid,
              startdate: response.data.retData[2][0].startdate,
              enddate: response.data.retData[2][0].enddate,
              worklocation: response.data.retData[2][0].worklocation,
              workduration: response.data.retData[2][0].workduration, 
              note: response.data.retData[2][0].note,
              status: response.data.retData[2][0].statusname,
              dkey: prevState.dkey + 1,
              data: response.data.retData[2][0],
              product_requirement: response.data.retData[2][0].product_requirement,
              owner_products_supply: response.data.retData[2][0].owner_products_supply,
              isMasterContract: response.data.retData[2][0].is_master_contract,
            }));
          }
        }
      }
    );
  };

  componentDidMount = () => {
    localStorage.removeItem("productreq");
    localStorage.removeItem("ownersupply");
    this.getData();
  };
  
  onChangeStage = (e) => {
    if (e !== 0 && e < 7) {  
      this.setState({ stage: e });
    } else {
      let stage = this.state.stage;
      if (stage < 7)
      this.setState({ stage: stage + 1 });
    }
  };

  onChangeValue = (name, value) => {
    this.setState({ [name]: value });
  };

  onChangeMasterContract = (value) => {
    console.log("checkbox value: ", value);
    this.setState({ isMasterContract: value == true ? 1 : 0 });    
  };

  buildRequestBody = () => {
    const { joinworkid, productreq, ownersupply } = this.state;
    return {
      joinworkid, products_requirements: productreq, owners_product_supply: ownersupply
    };
  }

  saveJoinWorkProductRequirement = async (body) => {
    try {
      const response = await API.post("/saveJoinWorkProductRequirement", body);
      if (response.status === 200) {
        message.success("Амжилттай хадгаллаа.");
      }
    } catch (error) {
      message.error("Хадгалалт амжилтгүй боллоо.");
    }
  };

  onSave = () => {
    const { joinworkid, productreq, ownersupply } = this.state;
    const body = this.buildRequestBody();
    this.saveJoinWorkProductRequirement(body);
    localStorage.setItem('joinworkid', joinworkid);
    localStorage.setItem('productreq', productreq);
    localStorage.setItem('ownersupply', ownersupply);
  };

  saveJoinWork = async (body) => {
    try {
      const response = await API.post("/saveJoinWork", body);
      if (response.status === 200) {
        message.success("Амжилттай хадгаллаа.");
      }
    } catch (error) {
      message.error("Хадгалалт амжилтгүй боллоо.");
    }
  };

  onSaveInvitation = () => {
    const { joinworkid, joinworkname, tendertypeid, departmentid, startdate, enddate, workduration, worklocation, note, isMasterContract } = this.state;
    let body = { joinworkid, joinworkname, tendertypeid, departmentid, startdate, enddate, workduration, worklocation, note, is_master_contract: isMasterContract, }
    this.saveJoinWork(body);
    this.getData();
  };

  onPublishInvitation = async () => {
    try {
      const { joinworkid, joinworkname, tendertypeid, departmentid, startdate, enddate, workduration, worklocation, note } = this.state;
      // let body = { joinworkid, joinworkname, tendertypeid, departmentid, startdate, enddate, workduration, worklocation, note, }
      // const response = await API.post("/saveJoinWork", body);
      // if (response.status === 200) {
        let bodystatus = { joinworkid, status:3 }
        const response = await API.post("/publishJoinWorkInvitation", bodystatus);
        if (response.status === 200) {
          message.success("Амжилттай нийтэллээ.");
          this.setState({status: 3});
        }
      // }
    } catch (error) {
      message.error("Үйлдэл амжилтгүй боллоо.");
    }
    this.setState({popConfirmVisible: false});
  }
  onChangePopConfirmVisible = (visible) => {
    this.setState({ popConfirmVisible: visible });    
  };

  confirmationPopup = () => {
    return (
      <PopConfirm
        question="Та Хамтран ажиллах урилгыг вэб сайт дээр нийтлэх гэж байна. Итгэлтэй байнуу?"
        onClickYes={this.onPublishInvitation}
        onClickNo={() => {
          this.onChangePopConfirmVisible(false);
        }}
      />
    );
  };

  sendMassMail = () => {
    let body = {
      url: baseConfig.makurl, 
      joinworkid: this.state.joinworkid,
      joinworkname: this.state.joinworkname,
      enddate: this.state.enddate,
      note: this.state.note
    }
    API.post("/sendNewJoinWorkNotification", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Имэйл амжилттай илгээгдсэн.");
        this.setState({ status: 1 });       
      }
    });
  };  
  render() { 
    return (
      <div>
        <div style={{ backgroundColor: "white" }}>
          <JoinWorkHeader joinworkid={this.state.joinworkid} pdata = {this.state.data}/>
        </div>    
        <div>
           <div style={{ backgroundColor: "white" }}>
            <div className="mainContainer">
              <Row gutter={(16, 16)} justify="start" align="middle">
                <Col span={2.1}>
                  <Row justify="start" align="middle">
                    <Col>
                      <div className="stageCircle">
                        <ButtonStage
                          onClick={() => this.onChangeStage(1)}
                          value={this.state.stage === 1 ? 1 : <StageSuccess />}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="stageLabel">Хийгдэх ажлууд</div>
                    </Col>
                  </Row>
                </Col>
                <Col style={{ marginLeft: -10, marginTop: 3 }} span={1}>
                  <div className="stageBorder" style={{borderColor: this.state.stage > 1 ? "#0358A7" : "#E5E5E5"}}></div>
                </Col>
                <Col style={{ marginLeft: -15 }} span={2.1}>
                  <Row justify="start" align="middle">
                    <Col>
                      <div className="stageCircle">
                        <ButtonStage
                          onClick={() => this.onChangeStage(2)}
                          value={this.state.stage > 2 ? <StageSuccess /> : 2}
                          disabled={this.state.stage < 2 ? true : false}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="stageLabel">Тавигдах шаардлага, бүрдүүлэх материал</div>
                    </Col>
                  </Row>
                </Col>
                <Col style={{ marginLeft: -10, marginTop: 3 }} span={1}>
                  <div className="stageBorder" style={{borderColor: this.state.stage > 2 ? "#0358A7" : "#E5E5E5"}}></div>
                </Col>
                <Col style={{ marginLeft: -15 }} span={2.1}>
                  <Row justify="start" align="middle">
                    <Col><div className="stageCircle">
                        <ButtonStage
                          onClick={() => this.onChangeStage(3)}
                          value={this.state.stage > 3 ? <StageSuccess /> : 3}
                          disabled={this.state.stage < 3 ? true : false}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="stageLabel">Барааны шаардлага, Захиалагчийн нийлүүлэх бараа</div>
                    </Col>
                  </Row>
                </Col>
                <Col style={{ marginLeft: -10, marginTop: 3 }} span={1}>
                  <div className="stageBorder" style={{borderColor: this.state.stage > 3 ? "#0358A7" : "#E5E5E5"}}></div>
                </Col>   
                <Col style={{ marginLeft: -15 }} span={2.1}>
                  <Row justify="start" align="middle">
                    <Col>
                      <div className="stageCircle">
                        <ButtonStage
                          onClick={() => this.onChangeStage(4)}
                          value={this.state.stage > 4 ? <StageSuccess /> : 4}
                          disabled={this.state.stage < 4 ? true : false}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="stageLabel">Нэмэлт материал</div>
                    </Col>
                  </Row>
                </Col>
                <Col style={{ marginLeft: -10, marginTop: 3 }} span={1}>
                  <div className="stageBorder" style={{borderColor: this.state.stage > 4 ? "#0358A7" : "#E5E5E5"}}></div>
                </Col>
                <Col style={{ marginLeft: -15 }} span={2.1}>
                  <Row justify="start" align="middle">
                    <Col>
                      <div className="stageCircle">
                        <ButtonStage
                          onClick={() => this.onChangeStage(5)}
                          value={this.state.stage > 5 ? <StageSuccess /> : 5}
                          disabled={this.state.stage < 5 ? true : false}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="stageLabel">Материал хүлээн авах хаяг</div>
                    </Col>
                  </Row>
                </Col>
                <Col style={{ marginLeft: -10, marginTop: 3}} span={1}>
                  <div className="stageBorder" style={{borderColor: this.state.stage > 5 ? "#0358A7" : "#E5E5E5"}}></div>
                </Col>
                <Col style={{ marginLeft: -15 }} span={2.1}>
                  <Row justify="start" align="middle">
                    <Col>
                      <div className="stageCircle">
                        <ButtonStage onClick={() => this.onChangeStage(6)}
                          value={this.state.stage > 6 ? <StageSuccess /> : 6}
                          disabled={this.state.stage < 6 ? true : false}/>
                      </div>
                    </Col>
                    <Col>
                      <div className="stageLabel">Урилга</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
          <div className="mainContainer">
              {this.state.stage === 1 ? (
                <JoinWorkTask

                  isEdit={true}
                  joinworkid={this.state.joinworkid}
                  joinworkname={this.state.joinworkname}
                />
                ) : this.state.stage === 2 ? (
                  <JoinWorkRequirementList
                    joinworkid={this.state.joinworkid}
                    isEdit={true}
                  />
                ) : this.state.stage === 3 ? (
                  <JoinWorkProductReq
                    joinworkid={this.state.joinworkid}
                    joinworkproductreq={this.state.product_requirement}
                    joinworkownersupply={this.state.owner_products_supply}
                    isEdit={true}
                  />
                ): this.state.stage === 4 ? (
                  <JoinWorkDocumentList
                    joinworkid={this.state.joinworkid}
                    isEdit={true}
                  />
                ): this.state.stage === 5 ? (
                  <JoinWorkNoteList
                    joinworkid={this.state.joinworkid}
                    isEdit={true}
                  />
                ) : this.state.stage === 6 ? (
                  <div id="JobWorkInvitationID">
                    <Row justify="start" align="middle"  gutter={[16, 16]} style={{padding:'5px', marginBottom: '5px'}}><Col className="HeaderLabel">6. Хамтран ажиллах урилга</Col></Row>
                    <Row justify="end" align="middle">
                      <Col style={{ marginTop: -70 }}>
                        <PrintComponent
                          buttonText="Урилга татах"
                          content={<JoinWorkToPDF joinworkid={this.state.joinworkid} joinworkname={this.state.joinworkname} />}
                        />
                      </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{padding:'5px', marginBottom: '5px'}}>
                      <Col span={12}>
                          <Form.Item
                            label="Зарлах огноо"
                            name="startdate"
                            rules={[{required: true,message: "Зарлах огноо сонгоно уу.",},]}
                          >
                            <DatePicker
                              defaultValue={ this.state.startdate ? moment(this.state.startdate, dateFormat): null}
                              onChange={(e) => this.onChangeValue("startdate", e)}
                              format={dateFormat}
                              placeholder=""
                            ></DatePicker>
                          </Form.Item>
                        </Col> 
                        <Col span={12}>
                        <Form.Item
                            label="Дуусах огноо"
                            name="enddate"
                            rules={[{required: true,message: "Хамтран ажиллах санал хүлээн авах эцсийн хугацаа сонгоно уу.",},]}
                          >
                            <DatePicker
                              defaultValue={ this.state.enddate ? moment(this.state.enddate, dateFormat): null}
                              onChange={(e) => this.onChangeValue("enddate", e)}
                              format={dateFormat}
                            ></DatePicker>
                        </Form.Item>  
                        </Col>
                    </Row> 
                    <Row>
                        <Col span={12}>
                          <Form.Item
                            label="Ажил хийгдэх хугацаа"
                            name="workduration"
                            rules={[{required: true,message: "Ажил хийгдэх хугацааг оруулна уу.",},]}>
                            <Input
                              onChange={(e) => this.onChangeValue("workduration", e.target.value)}
                              size="middle" defaultValue={this.state.workduration}/>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Ажил хийгдэх байршил"
                            name="worklocation"
                            rules={[{required: true,message: "Ажил хийгдэх байршил оруулна уу.",},]}>
                            <Input
                              onChange={(e) => this.onChangeValue("worklocation", e.target.value)}
                              size="middle" defaultValue={this.state.worklocation}/>
                          </Form.Item>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10, marginLeft: 5 }} gutter={(16, 16)}>
                        <Checkbox 
                          defaultChecked={this.state.isMasterContract == 1 ? true : false}
                          onChange={(e) => this.onChangeMasterContract(e.target.checked)}
                        >
                          Мастер гэрээ байгуулах
                        </Checkbox>
                    </Row>
                    <Row style={{ marginTop: 10 }} gutter={(20, 16)}>
                        <Col span={24}><div className="Label">Дэлгэрэнгүй тайлбар</div>
                          <TextArea
                            rows={6}
                            defaultValue={this.state.note}
                            onChange={(e) => this.onChangeValue("note", e.target.value)}
                            disabled={false}
                          />
                        </Col>
                    </Row>
                    <Row style={{paddingTop: '5px'}}>
                        <Col>
                          <Button type="primary" className="btnPrimary" htmlType="submit" disabled={this.state.isEdit ? false : false}
                            onClick={this.onSaveInvitation}>Урилга Хадгалах
                          </Button>
                        </Col>
                        <Col style={{paddingLeft: '8px'}}>
                          <Popover
                            placement="bottomRight"
                            title="Санамж"
                            content={this.confirmationPopup}
                            trigger="click"
                            visible={this.state.popConfirmVisible}
                          >
                              <Button type="primary" className="btnPrimary" htmlType="submit" disabled={this.state.isEdit ? false : true}
                                onClick={() => this.onChangePopConfirmVisible(true)}>Урилга нийтлэх
                              </Button>
                          </Popover>
                        </Col>
                        { this.context.permission.isAdmin === "1" ?
                          <>
                            <Col style={{paddingLeft: '8px'}}>
                              <Button type="primary"
                                className="btnPrimary"
                                style={{marginRight: 10,}}
                                htmlType="submit"
                                onClick={() => this.sendMassMail()}
                              >ХА урилгын масс имэйл илгээх
                              </Button>
                            </Col>
                          </>
                        : null}  
                    </Row>   
                  </div>
                ) : null}
          </div>
          {this.state.stage < 6 ?
          <div className="mainContainer">
              <Row style={{ height: 56 }} justify="start" align="middle">
                  <Col>       
                    <Button
                      type="primary"
                      className="btnSecondary"
                      htmlType="submit"
                      onClick={() => this.onChangeStage(0)}>Дараагийн алхам
                    </Button>
                  </Col>
              </Row>           
          </div> : null }
        </div>
        
      </div>
    );
  }
}
export default withRouter(JoinWorkInvitation);
